import * as Styled from "./style";
import { BreadcrumbsListBlock } from "~/components/blocks/product/common/blocks/breadcrumbs-list-block";
import { ProductBanner } from "~/components/blocks/product/common/blocks/product-banner";
import { ProductDescription } from "~/components/blocks/product/common/blocks/product-description";
import { ProductHelpBanner } from "~/components/blocks/product/common/blocks/product-help-banner";
import { BannerItem } from "~/components/blocks/product/common/blocks/product-related-items/collection-banner-item";
import { CollectionItem } from "~/components/blocks/product/common/blocks/product-related-items/collection-item";
import { RecommendItem } from "~/components/blocks/product/common/blocks/product-related-items/recommend-item";
import { ProductTitle } from "~/components/blocks/product/common/blocks/product-title";
import { AffiliateButton } from "~/components/blocks/product/common/blocks/product-title/action-buttons/affiliate";
import { VideoSeasonTab } from "~/components/blocks/product/common/video-season/video-season-tab";
import type { VideoSeasonType } from "~/components/blocks/product/type-guard";
import { useRatingBlock } from "~/hooks/use-rating-block";

type VideoSeasonProps = { videoSeasonData: VideoSeasonType };

export const VideoSeason = (props: VideoSeasonProps) => {
  const { videoSeasonData } = props;
  // MEMO: 未ログインかつR15/R18作品の場合は棚を非表示にする
  const { isRestrictedContentByUserStatus } = useRatingBlock();
  const ratingCategory = videoSeasonData.rating.category;

  return (
    <>
      <ProductBanner videoData={videoSeasonData} />

      <Styled.DivProductTitlePadding>
        <AffiliateButton />
        <ProductTitle videoData={videoSeasonData} />
        <ProductHelpBanner videoData={videoSeasonData} />
        <ProductDescription videoData={videoSeasonData} />
        <VideoSeasonTab
          videoData={videoSeasonData}
          isAdultBlock={!isRestrictedContentByUserStatus(ratingCategory, true)}
        />
      </Styled.DivProductTitlePadding>

      <Styled.DivProductItemsFlexContainer>
        {!isRestrictedContentByUserStatus(ratingCategory, true) && <RecommendItem />}
        <BannerItem bannerType="scratch" videoData={videoSeasonData} />
        <BannerItem bannerType="onlineCrane" videoData={videoSeasonData} />
        {!isRestrictedContentByUserStatus(ratingCategory, true) && (
          <>
            <CollectionItem collectionType="videos" videoData={videoSeasonData} />
            <CollectionItem collectionType="books" videoData={videoSeasonData} />
          </>
        )}
        <BannerItem bannerType="mono" videoData={videoSeasonData} />
      </Styled.DivProductItemsFlexContainer>

      <BreadcrumbsListBlock videoData={videoSeasonData} />
    </>
  );
};
